import React from 'react'
import { Helmet } from 'react-helmet'
import utils from '../../utils'
import Statistics from '../../components/dashboard/Statistics'
import RecentRecords from '../../components/dashboard/RecentRecords'
import DashboardMetrics from '../../components/dashboard/DashboardMetrics'

function AdminDashboardPage(props) {
    const url = window.location.href
    return (
        <div>
            <Helmet>
                <title>Admin Dashboard - {utils.siteName}</title>
                <link rel="canonical" href={url} />
                <meta
                    property="description"
                    content="" />
            </Helmet>

            <div className="container mx-auto space-y-7">
                <div className="flex flex-col md:flex-row md:items-end justify-between gap-4">
                    <div>
                        <h1 className="text-3xl font-bold text-zinc-90 tracking-tight">Platform Overview</h1>
                        <p className="text-zinc-500 mt-1">Metrics on patients, nurses and requests.</p>
                    </div>
                    
                </div>
                <Statistics/>
                <RecentRecords/>
                <DashboardMetrics/>

            </div>
        </div>
    )
}

export default AdminDashboardPage